import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { watchThrottled } from '@vueuse/core';
import { cacheControl } from '~/helpers/cacheControl';
import { instantScrollTo } from '~/helpers/ui/windowBehaviors';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { useEssentialOilListingStore } from '~/composables/_next/stores/useEssentialOilListingStore';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { useSegment } from '~/composables/_next/useSegment';
import AlphabeticalSorting from '~/components/shared/AlphabeticalSorting.vue';
import AppCategoriesHeader from '~/components/Layout/AppCategoriesHeader.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import EssentialOilsGuideCard from '~/components/Molecules/EssentialOilsGuideCard.vue';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import SearchFiltersOrganism from '~/components/_next/organisms/search/SearchFiltersOrganism.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzRichText from '~/components/_next/atoms/AzRichText.vue';
import AzSeoBlock from '~/components/_next/molecules/AzSeoBlock.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import CardSkeleton from '~/assets/images/skeletons/card.svg?inline';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=7200, stale-while-revalidate=3600, stale-if-error=3600') // 2 hours cache and 1 hour stale
      ],tracking: {
        category: TrackingPageCategory.EOLP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: 'guides',
  setup: function setup(__props) {
    ;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var router = useRouter();
    var route = useRoute();
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;
    var _useNuxt2App2 = useNuxt2App(),
      error = _useNuxt2App2.error,
      i18n = _useNuxt2App2.i18n;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta,
      getOptionAttributeNamesFromFacets = _useLegacySeoMeta.getOptionAttributeNamesFromFacets;
    var _useEssentialOilListi = useEssentialOilListingStore(),
      essentialOils = _useEssentialOilListi.essentialOils,
      essentialOilsAll = _useEssentialOilListi.essentialOilsAll,
      essentialOilListingPage = _useEssentialOilListi.essentialOilListingPage,
      fetchEssentialOilListing = _useEssentialOilListi.fetchEssentialOilListing,
      fetchEssentialOilListingContent = _useEssentialOilListi.fetchEssentialOilListingContent,
      essentialOilListingProducts = _useEssentialOilListi.essentialOilListingProducts,
      essentialOilListingFacets = _useEssentialOilListi.essentialOilListingFacets,
      essentialOilsPagination = _useEssentialOilListi.essentialOilsPagination,
      essentialOilListingSelectedLetter = _useEssentialOilListi.essentialOilListingSelectedLetter,
      essentialOilListingLetterFilters = _useEssentialOilListi.essentialOilListingLetterFilters;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var _useSearchFacets = useSearchFacets(),
      facets = _useSearchFacets.facets,
      clearSearchFacets = _useSearchFacets.clearSearchFacets;
    watchThrottled(facets, fetchEssentialOilListing, {
      throttle: 1000
    });
    var _useLazyAsyncData = useLazyAsyncData('essential-oils-listing', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _essentialOilListingP, _essentialOilListingP2;
        var seo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchEssentialOilListingContent();
            case 2:
              if (essentialOilListingPage.value) {
                _context.next = 5;
                break;
              }
              error({
                statusCode: 404
              });
              return _context.abrupt("return", true);
            case 5:
              _context.next = 7;
              return fetchEssentialOilListing();
            case 7:
              if (essentialOils.value) {
                _context.next = 10;
                break;
              }
              error({
                statusCode: 404
              });
              return _context.abrupt("return", true);
            case 10:
              seo = _objectSpread(_objectSpread({
                title: (_essentialOilListingP = essentialOilListingPage.value) === null || _essentialOilListingP === void 0 ? void 0 : _essentialOilListingP.title
              }, (_essentialOilListingP2 = essentialOilListingPage.value) === null || _essentialOilListingP2 === void 0 ? void 0 : _essentialOilListingP2.seo), {}, {
                slug: transformSlugsForSeo(essentialOilListingPage.value)
              });
              setMeta(seo);
              return _context.abrupt("return", true);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))),
      pending = _useLazyAsyncData.pending;
    var sidebar = ref(null);
    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      sidebar.value.sidebar.showModal();
    }
    /**
     * Closes the filters sidebar.
     */
    function closeSidebar() {
      sidebar.value.sidebar.close();
    }
    function onClearFilters() {
      return _onClearFilters.apply(this, arguments);
    }
    function _onClearFilters() {
      _onClearFilters = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return clearSearchFacets();
            case 2:
              closeSidebar();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _onClearFilters.apply(this, arguments);
    }
    var seoProducts = computed(function () {
      var _essentialOilListingP3, _essentialOilListingP4, _essentialOilListingP5;
      var skus = new Set(essentialOilsAll.value.map(function (item) {
        return item.productSkuAssociated;
      }));
      return (_essentialOilListingP3 = essentialOilListingProducts.value) === null || _essentialOilListingP3 === void 0 ? void 0 : (_essentialOilListingP4 = _essentialOilListingP3.data) === null || _essentialOilListingP4 === void 0 ? void 0 : (_essentialOilListingP5 = _essentialOilListingP4.results) === null || _essentialOilListingP5 === void 0 ? void 0 : _essentialOilListingP5.flatMap(function (item) {
        var name = item.name,
          slug = item.slug,
          sku = item.masterVariant.sku;
        return skus.has(sku) ? [{
          name: name,
          slug: slug,
          sku: sku
        }] : [];
      });
    });
    var breadcrumbs = computed(function () {
      var _essentialOilListingP6, _essentialOilListingP7;
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: i18n.t('utils.homeBreadcrumbs')
      }, {
        link: app.localePath((_essentialOilListingP6 = essentialOilListingPage.value) === null || _essentialOilListingP6 === void 0 ? void 0 : _essentialOilListingP6.slug),
        text: (_essentialOilListingP7 = essentialOilListingPage.value) === null || _essentialOilListingP7 === void 0 ? void 0 : _essentialOilListingP7.title
      }];
    });
    var essentialOilsByLetter = computed(function () {
      var groupedResults = [];
      var groupedItems = essentialOils.value.reduce(function (acc, oil) {
        var firstLetter = oil.firstLetterTitle;
        acc[firstLetter] = acc[firstLetter] || [];
        acc[firstLetter].push(oil);
        return acc;
      }, {});
      for (var _i = 0, _Object$entries = Object.entries(groupedItems); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          letter = _Object$entries$_i[0],
          items = _Object$entries$_i[1];
        groupedResults.push({
          items: items.sort(function (a, b) {
            return a.title.localeCompare(b.title);
          }),
          letter: letter
        });
      }
      return groupedResults;
    });
    function filterByLetter(letter) {
      router.push({
        query: _objectSpread(_objectSpread({}, route.query), {}, {
          page: 1,
          letter: essentialOilListingSelectedLetter.value === letter ? essentialOilListingLetterFilters.value[0] : letter
        })
      });
    }
    var filteredParamNames = computed(function () {
      // get all query parameters that can be set from facets
      return getOptionAttributeNamesFromFacets(essentialOilListingFacets.value);
    });
    onMounted(function () {
      instantScrollTo({
        top: 0
      });
      setDynamicYieldContext('OTHER', ['Oil_Listing_Page']);

      // TODO: Remove after Nuxt 3 migration
      var _useSegment = useSegment(),
        analytics = _useSegment.analytics;
      analytics.page(TrackingPageCategory.ALP, PageTypes.ALP, {
        path: route.fullPath
      });
    });
    setDynamicYieldContextSSR('OTHER', ['Oil_Listing_Page']);
    return {
      __sfc: true,
      app: app,
      router: router,
      route: route,
      transformSlugsForSeo: transformSlugsForSeo,
      error: error,
      i18n: i18n,
      locale: locale,
      setMeta: setMeta,
      getOptionAttributeNamesFromFacets: getOptionAttributeNamesFromFacets,
      essentialOils: essentialOils,
      essentialOilsAll: essentialOilsAll,
      essentialOilListingPage: essentialOilListingPage,
      fetchEssentialOilListing: fetchEssentialOilListing,
      fetchEssentialOilListingContent: fetchEssentialOilListingContent,
      essentialOilListingProducts: essentialOilListingProducts,
      essentialOilListingFacets: essentialOilListingFacets,
      essentialOilsPagination: essentialOilsPagination,
      essentialOilListingSelectedLetter: essentialOilListingSelectedLetter,
      essentialOilListingLetterFilters: essentialOilListingLetterFilters,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      facets: facets,
      clearSearchFacets: clearSearchFacets,
      pending: pending,
      sidebar: sidebar,
      openSidebar: openSidebar,
      closeSidebar: closeSidebar,
      onClearFilters: onClearFilters,
      seoProducts: seoProducts,
      breadcrumbs: breadcrumbs,
      essentialOilsByLetter: essentialOilsByLetter,
      filterByLetter: filterByLetter,
      filteredParamNames: filteredParamNames,
      AlphabeticalSorting: AlphabeticalSorting,
      AppCategoriesHeader: AppCategoriesHeader,
      AzBackToTopButton: AzBackToTopButton,
      EssentialOilsGuideCard: EssentialOilsGuideCard,
      AzPagination: AzPagination,
      MobileFiltersButton: MobileFiltersButton,
      NuxtLinkCustom: NuxtLinkCustom,
      SearchFiltersOrganism: SearchFiltersOrganism,
      AzSidebar: AzSidebar,
      AzRichText: AzRichText,
      AzSeoBlock: AzSeoBlock,
      AzButton: AzButton,
      CardSkeleton: CardSkeleton,
      AzIcon: AzIcon
    };
  }
});